<template>
<div class="page">
    <div class="listHead">
        <!-- <div  v-if="!isApp&&!isWeixinFlag" class="titleBox"><img @click="goBack()" src="@/assets/img/icon_left.png">征集送拍</div> -->
        <cpn-panel v-if="!isApp" :extinfo="extinfo" :isDetail="true" :showDownloadCloseBtn="false" :showNav="true" :showBtn="false" wapTitle="征集送拍" />
        <div class="sendBtn" :style="isApp?'margin-top: 0rem !important;':''" @click="jumpForm()">
            <img src="@/assets/img/sendTitleIcon2.png" alt="">
            <span>立即送拍</span>
        </div>
        <!-- <div class="numBox">征集信息（{{titleName}}家拍行）</div> -->
        <div class="numBox">拍行征集日历</div>
        <van-list v-model="loading" :finished="finished" finished-text="" @load="onLoad">
            <template v-for="(item,i) in collectList">
                <div :key="'collect_List'+i" class="collectCard" @click="jumpDetails(item)">
                    <div class="collectName"><img class="nameImg" :src="item.organ_logo" alt=""> <span>{{item.organ_name}}</span>
                        <img v-if="item.isZhongpai==1" @click.stop="gyFun(item)" class="gyImg" src="@/assets/img/Frame205@2x.png" alt="">
                    </div>
                    <div class="coverBox">
                        <img :src="item.cover" @error="errorImg($event)" alt="">
                        <div v-if="item.have_list>0" class="more">
                            <img src="@/assets/img/group_bg.png">
                        </div>
                    </div>

                    <div class="dateBox" :style="item.have_list>0?'margin-top: 0.5rem;':''">{{item.time_str}}</div>
                </div>

            </template>
        </van-list>
        <div class="noMore" v-if="noMore">
            <span>我是有底线的</span>
        </div>

    </div>
    <DownLoadApp ref="downloadPop"></DownLoadApp>
    <gyBox ref="gyBox"></gyBox>
</div>
</template>

<script>
import {
    getWXConfig
} from "@/assets/js/weixinShare";
import DownLoadApp from '@/components/common/downloadApp'
import cpnPanel from "@/views/preview/component/panel.vue";
import {
    collectOrganList
} from "@/api/new";
import {
    isiOS,
    isWeixin
} from "@/api/auction/isWeixin";
import {
    getApp
} from "@/api/request";
import gyBox from "@/components/common/gyBox";
import {
    gotoLogin,
    scMdFunc
} from "@/assets/js/scData";
export default {
    components: {
        DownLoadApp,
        cpnPanel,
        gyBox
    },
    data() {
        return {
            isApp: true,
            version: 0,
            isLogin: 0,
            collectList: [],
            appLinkShow: true,
            // 通链接数据
            appLink: '/2/8/0',
            loading: false,
            finished: false,
            isWeixinFlag:false,
            noMore: false,
            extinfo:"",
            titleName: ''
        }
    },
    methods: {
        onLoad() {
            this.getNewsData();

        },
        jumpForm() {
            if (this.isLogin) {
                scMdFunc('songpaiPageView', {
                    source_page: '征集列表',
                })
                window.location.href = "https://m-auction.artron.net/sendForm?form=other"
            } else {
                gotoLogin()
            }

        },
        gyFun(e) {
            this.$refs.gyBox.showGY(true, {
                cover: e.organ_logo,
                name: e.organ_name
            });
        },
        errorImg(e) {
            console.log(e)
            e.srcElement.src = require('../../assets/img/Nulldata.png');
            e.srcElement.style.background = "#fff";
            e.srcElement.style.objectFit = "scale-down";
            e.srcElement.style.height = "5.5rem";
            e.srcElement.onerror = null; //防止闪图
        },
        getNewsData() {
            let params = {
                page: this.page,
            }
            // this.loading = true;
            collectOrganList(params).then((res) => {
                if (res.code == 0) {
                    this.titleName = res.data.total
                    this.isLogin = res.data.isLogin
                    if (res.data.morePage == 0 && res.data.list.length == 0) {
                        this.loading = false;
                        this.finished = true;
                    } else if (res.data.list.length) {
                        this.collectList = this.collectList.concat(res.data.list);
                        this.loading = false;
                        this.page++;
                        if (res.data.morePage == 0) {
                            this.finished = true;
                            this.noMore = true;
                        }
                    }
                    document.title = "征集送拍"
                    window.AFedWxShareData = {
                        title: '2024拍行征集日程，附送送拍渠道',
                        imgUrl: 'https://tulu.artron.net/static/tulu_icon/collect.jpeg',
                        desc: '雅昌拍卖图录全能助手，拍卖无忧',
                        link: res.data.shareMessage.url
                    }
                    getWXConfig(window.AFedWxShareData);
                }
            });
        },
        jumpDetails(e) {
            let that = this;
            let bridge = window.WebViewJavascriptBridge;

            if (e.have_list == 0) {
                if (e.source_type == 2) {
                    if (this.isApp) {
                        // bridge.callHandler('GotoAppNewsDetail', {
                        //         show_type: 1,
                        //         resource_id: newArray[0].new_url_app
                        //     }, function () {})
                        if (this.version >= 6138000) {
                            bridge.callHandler('GotoAppNewsDetail', {
                                resource_id: e.source_id
                            }, function () {})
                        } else {
                            if (isiOS) {
                                window.location.href = 'https://m-auction.artron.net/tulu/wap/share/news?id=' + e.source_id
                            } else {
                                that.$refs.downloadPop.gotoAppDownload('/2/40/1/' + e.source_id, 0)
                            }
                        }

                    } else {

                        window.location.href = 'https://m-auction.artron.net/tulu/wap/share/news?id=' + e.source_id

                        // window.location.href = newArray[0].new_url_app
                    }

                }
                if (e.source_type == 1) {
                    if (this.isApp) {
                        bridge.callHandler('GotoAppArticleDetail', {
                            id: e.source_id
                        }, function () {})

                    } else {

                        window.location.href = 'https://m-auction.artron.net/topics/' + e.source_id

                    }

                }

            } else {
                this.$router.push({
                    path: "/collectDetails?showRank=" + e.id + "&showName=" + e.organ_name
                });
            }
        },
        getAppFun() {
            getApp('/source').then((res) => {
                if (res.data.isApp) {
                    this.version = res.data.version
                }
            })
        },
        goBack() {
            if (document.referrer) {
                window.location.href = document.referrer
            } else if (window.history.state) {
                this.$router.back()
            } else if (this.$route.query.fromlink) {
                window.location.href = decodeURIComponent(this.$route.query.fromlink)
            } else {
                this.$router.push({
                    path: "/"
                });
            }
        },

    },
    created() {
        this.getAppFun()
    },
    mounted() {
        this.isApp = (/(SwiftTuLu|ArtronTulu|HarmonyOSTulu)/g).test(window.navigator.userAgent)
        this.extinfo=JSON.stringify({url: "h5",param: window.location.href})
        this.isWeixinFlag=isWeixin()
    }
}
</script>

<style lang="scss">
body {
    background: #F5F5F5 !important;
}
</style>
<style lang="scss" scoped>
@import url("../../assets/css/reset.css");

.page {
    background-color: #F5F5F5;

    .sendBtn {
        margin: auto;
        padding: 0.76rem 0.94rem;
        width: calc(100% - 1.88rem);
        background: url(../../assets/img/sendTitleBg2.png) no-repeat;
        background-size: cover;
        box-sizing: border-box;
        border-radius:  0.47rem;
        font-weight: 400;
        font-size:  0.47rem;
        margin-top: .5rem;
        color: #000000;
        position: relative;

        img {
            width: 60%;
            max-width: 9.3rem;
            // height: 2rem;
        }

        span {
            padding: 0.23rem 0.47rem;
            background: linear-gradient(90deg, #3A3A3B 0%, #1B1B1D 100%), #009B5F;
            border-radius: 0.23rem;
            color: #D9CAB4;
            font-weight: 400;
            font-size: .55rem;
            position: absolute;
            top: 1.2rem;
            right: 0.6rem;
        }
    }

    .listHead {

        width: 100%;
        height: 12rem;
        padding-top: 0.5rem;
        background: linear-gradient(180deg, #FFFFFF 63%, rgba(255, 255, 255, 0) 97%);

        .collectCard {
            width: 90%;
            margin: 1rem 5%;
            background: #FFFFFF;
            box-shadow: 0 0.82rem 1.52rem -0.58rem rgba(0, 0, 0, 0.1);
            border-radius: 1rem;
            padding-bottom: 0.5rem;
            box-sizing: border-box;

            .dateBox {
                width: 100%;
                padding: 0.5rem 1rem;
                font-size: 0.6rem;
                font-weight: 400;
                margin-top: 0.29rem;
                box-sizing: border-box;

            }

            .coverBox {
                width: 100%;
                padding: 0 0.8rem;
                box-sizing: border-box;
                position: relative;

                img {
                    width: 100%;
                    height: 100%;
                    position: relative;
                    z-index: 3;
                    border-radius: 1rem;
                }

                .more {
                    position: absolute;
                    width: 80%;
                    height: 4.7rem;
                    left: 10%;
                    bottom: -0.23rem;
                    z-index: 2;
                }
            }

            .collectName {
                width: 100%;
                padding: 0.5rem 1rem;
                box-sizing: border-box;

                .nameImg {
                    width: 2rem;
                    height: 2rem;
                    object-fit: contain;
                    margin-right: 0.2rem;
                    border-radius: 2rem;
                    border: 0.05rem solid rgba(0, 0, 0, 0.06);
                    box-shadow: 0 0 0.11rem 0 rgba(0, 0, 0, 0.06);
                    vertical-align: middle;

                }

                .gyImg {
                    height: 0.8rem;
                    width: auto;
                    vertical-align: middle;
                    margin-left: 0.29rem;
                    margin-bottom: 0.29rem;
                }

                span {
                    font-size: 0.75rem;
                    font-weight: 600;
                }

            }
        }

        .numBox {
            font-size: 0.6rem;
            font-weight: 400;
            color: #000000;
            line-height: 2rem;
            padding-left: 1rem;
            margin-top: 0.2rem;
        }

        .titleBox {
            width: 100%;
            height: 2rem;
            z-index: 5;
            background: #FFFFFF;
            font-size: 0.7rem;
            line-height: 2rem;
            font-weight: 600;
            color: #000000;
            text-align: center;
            position: fixed;
            top: 0;
            left: 0;

            img {
                position: absolute;
                left: 0;
                top: 0;
                width: 2.82rem;
                height: 2.35rem;
            }
        }

    }

}
</style>
